module.exports = [
  'chooseImage',
  'previewImage',
  'uploadImage',
  'downloadImage',
  'getNetworkType',
  'getLocation',
  'scanQRCode',
  'getUA',
  'isApiSupported',
  'use',
  'openWebview',
  'share'
]


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/wx/miniprogram-h5-apis.js
// module id = 534
// module chunks = 0